import { render, staticRenderFns } from "./vistoriadores.vue?vue&type=template&id=a0d990c4"
import script from "./vistoriadores.vue?vue&type=script&lang=js"
export * from "./vistoriadores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports